import commerceConfig from '@commerce/config'
import usePrice from '@commerce/product/use-price'
import { ProductVariant } from '@commerce/types/product'
import { Quantity } from '@components/ui'
import processLocale from '@lib/locale'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC, useEffect, useState } from 'react'
import { SelectedOptions } from '../helpers'

interface props {
  option: ProductVariant
  currencyCode: string
  selectedOptions: SelectedOptions
  setSelectedOptions: React.Dispatch<React.SetStateAction<SelectedOptions>>
}

const ProductOptionByLitre: FC<props> = ({
  option,
  currencyCode,
  selectedOptions,
  setSelectedOptions,
}) => {
  const { t } = useTranslation('common')
  const price = usePrice({
    amount: option.price,
    currencyCode,
    suffix: `(${t('excl-vat')})`,
  })
  const { locale } = useRouter()
  const {
    config: { context },
  } = commerceConfig
  const currentLocale = processLocale(locale)
  const currentContext = context?.[currentLocale]
  const taxAmount = currentContext?.taxAmount
  const { price: afterTaxPrice } = usePrice({
    amount: option.price * (1 + taxAmount || 1),
    currencyCode,
    suffix: `(${t('incl-vat-approx')})`,
  })
  const [quantity, setQuantity] = useState(0)
  const handleQtyIncrease = () => {
    setQuantity((q) => ++q)
  }
  const handleQtyDecrease = () => {
    setQuantity((q) => --q)
  }
  useEffect(() => {
    if (quantity === 0) {
      setSelectedOptions((prevState) => {
        const state = { ...prevState }
        delete state[option.id]
        return state
      })
    } else {
      setSelectedOptions({ ...selectedOptions, [option.id]: quantity })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity])

  let i18nName = option.name?.replace('By Litre / ', '')
  i18nName = i18nName?.replaceAll('litre', t('litre')).replace('li', 'Li')

  return (
    <div className="flex h-auto w-full content-center justify-between rounded-sm border border-ui-grey-25 bg-white py-3 px-4">
      <div>
        <div className="body-2-bold text-ui-dark-grey">{i18nName}</div>
        <div className="body-2 mt-1 text-ui-dark-grey">{price.price}</div>
        {taxAmount && (
          <div className="body-2 mt-1 text-ui-dark-grey">{afterTaxPrice}</div>
        )}
      </div>
      <Quantity
        allowZero
        value={quantity}
        increase={handleQtyIncrease}
        decrease={handleQtyDecrease}
        classNames="bg-white border-ui-grey-25 min-w-22 md:min-w-32 justify-around label"
      />
    </div>
  )
}

export default ProductOptionByLitre
